import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import PerDiemForm from '../../perdiemLodging/page/perdiemLodging.mjs';
import PageShell from '../../components/PageShell.mjs';

/**
 * The ordinary per diem form, filing for the person chosen on the previous page.
 *
 * The claimant arrives in navigation state. A reload, or a direct visit, has
 * none - and a per diem form that does not know whose claim it is would file it
 * as the admin's own - so without it this sends you back to choose someone.
 *
 * This page owns the frame (PageShell), and PerDiemForm, given onBehalfOf,
 * renders without a frame of its own. The claimant's name stays in the form's
 * indigo box (its first surface), as on the expense form's on-behalf page.
 */
const PerDiemOnBehalf = () => {
  const { state } = useLocation();
  const onBehalfOf = state?.onBehalfOf;

  if (!onBehalfOf?.id) {
    return <Navigate to="/admin/file-claim" replace />;
  }

  return (
    <PageShell title="Per Diem & Lodging" width="7xl" photo={false}>
      <PerDiemForm onBehalfOf={onBehalfOf} />
    </PageShell>
  );
};

export default PerDiemOnBehalf;
